<template>
  <section>
    <b-notification type="is-info" :closable="false">
      <i class="icon-ic_alert-blue" />
      <strong>{{ infoTitle }}</strong>
      {{ infoText }}
    </b-notification>
  </section>
</template>

<script>
export default {
  name: 'Notification',
  data() {
    return {
      infoTitle: 'Solicitação em análise.',
      infoText:
        'Aguarde enquanto a nossa equipe médica analisa a sua solicitação.'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/forms';

.notification.is-info {
  border: 0.0625rem solid $light-blue;
  border-color: var(--light-blue);

  background-color: var(--neutral-color-5);

  color: var(--gray-700);
  margin-bottom: 1.5rem;
  text-align: justify;

  i {
    margin-right: 0.5rem;
    vertical-align: bottom;
  }
}
</style>
